import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getATVarP, getData, getDetalleVarTemp, getPeriodosAT, getPropieties, setLimitesM } from '../query';
import { getGini, getMayoresDeudores, getPeriodos } from './graph/querysRiesgoGeneral';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MayoresdeudoresAService {
  private readonly apiURL = environment.api_aleemaRiesgosGeneralRest;
  private readonly headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private headersRes = new HttpHeaders().append('Content-Type', 'application/json').append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  constructor(
    private apollo: Apollo,    
    private readonly cookies: CookieService,
    private http: HttpClient,
  ) { }

  /**
   * Obtiene los periodos disponibles para la plantilla de Alerta Temprana
   * @param idPlantilla ID de la plantilla
   * @returns Datos de evaluaciones
   */
  async getPeriodosAT(idPlantilla: number) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getPeriodosAT,
        context: { headers: this.headers },
        variables: { idPlantilla }
      }).valueChanges
    );
    return data;
  }
  /**
   * 
   * @param idInstitucion identificador de la institucion de acuerdo al administrador
   * @returns Periodos con informacion
   */
  async getPeriodosRiesgos(idInstitucion: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getPeriodos,
        context: { headers: this.headers },
        variables: { idInstitucion }
      }).valueChanges
    );
    return data
  }

  /**
   * Obtiene los datos de mayores deudores para un periodo
   * @param headers Headers con el token de autenticación
   * @param periodo Periodo en formato YYYY-MM-DD
   * @returns Datos de créditos ASI_03
   */
  async getData(periodo: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getData,
        context: { headers: this.headers },
        variables: { periodo }
      }).valueChanges
    );
    return data;
  }
  /**
   * obtiene la info de mayores deudores del back de riesgos general
   * @param anio año a consultar 
   * @param mes numero de mes a consultar 
   * @param idInst id del administrador  correspondiente a la institucion
   */
  async getDataRiesgos(anio: number, mes: number, idInst: string){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getMayoresDeudores,
        context: { headers: this.headers },
        variables: { anio: anio, mes: mes, idInstitucion: idInst }
      }).valueChanges
    );
    return data.getMayoresDeudores;
  }

  /**
   * Obtiene el detalle de una variable temporal de Alerta Temprana
   * @param idEvaluacion ID de la evaluación
   * @param idVarTemp ID de la variable temporal
   * @returns Detalle de la variable temporal
   */
  async getDetalleVarTemp(idEvaluacion: string, idVarTemp: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getDetalleVarTemp,
        context: { headers: this.headers },
        variables: { idEvaluacion, idVarTemp }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene el detalle de una cuenta de Alerta Temprana
   * @param idEvaluacion ID de la evaluación
   * @param idCuenta ID de la cuenta (P3, P312, P313, etc.)
   * @returns Detalle de la cuenta
   */
  async getATVarP(idEvaluacion: string, idCuenta: string) {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_alertaTemprana).watchQuery<any>({
        query: getATVarP,
        context: { headers: this.headers },
        variables: { idEvaluacion, idCuenta }
      }).valueChanges
    );
    return data;
  }

  /**
   * Obtiene las propiedades de créditos para un periodo específico
   * @param institucionId ID de la institución
   * @param periodo Periodo en formato YYYY-MM-DD
   * @param fetchPolicy Política de caché (opcional)
   * @returns Propiedades y límites de créditos
   */
  async getPropiedades(institucionId: string, periodo: string, fetchPolicy: 'no-cache' | 'cache-first' = 'cache-first') {
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).watchQuery<any>({
        query: getPropieties,
        fetchPolicy,
        context: { headers: this.headers },
        variables: { institucionId, periodo }
      }).valueChanges
    );
    return data;
  }

  /**
   * Establece o actualiza los límites de mayores deudores
   * @param periodo Periodo en formato YYYY-MM-DD
   * @param propiedades Objeto JSON con las propiedades y límites
   * @param institucionId ID de la institución
   * @returns Resultado de la mutación
   */
  async setLimites(periodo: string, propiedades: any, institucionId: string) {
    const result = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgos).mutate({
        mutation: setLimitesM,
        context: { headers: this.headers },
        variables: {
          periodo,
          propiedades,
          institucionId
        }
      })
    );
    return result;
  }

  /** 
   * @param limite 
   * @param segmento 
   */
  public postLimitesRiesgos(limite: {min:number, max: number, idInstitution: string, anio: number, mes: number}, segmento: string): Observable<any>{
    const body = JSON.stringify(limite);
    const apiURL = `${this.apiURL}limits-subcalculation/deudores/${segmento}`;
    return this.http.post(`${apiURL}`, body, { headers: this.headersRes});
  }

  public async getGini(idInstitution: string, anio: number, mes: number){
    const { data } = await firstValueFrom(
      this.apollo.use(environment.api_aleemaRiesgosGeneral).watchQuery<any>({
        query: getGini,
        context: { headers: this.headers },
        variables: { anio: anio, mes: mes, idInstitucion: idInstitution }
      }).valueChanges
    );
    return data.getGini;
  }
}